// extracted by mini-css-extract-plugin
export default {"block_item":"style_block_item__vg2ih"};